import React from 'react';
import { TextInput, Create, SimpleForm } from 'react-admin';
import EnumSelectInput from 'components/Enum/EnumSelectInput';

const ProfessionalBlockReasonCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <EnumSelectInput source="kind" />
      <TextInput source="label" />
    </SimpleForm>
  </Create>
);

export default ProfessionalBlockReasonCreate;
